












































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { PageTitleConfig } from '@/shared/msw-app-title/type';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';

const cssPrefix = 'terms-of-service';

@Component({
  components: {
    MswAppTitle,
    SwIcon,
  },
})
export default class TermsOfService extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;

  cssPrefix = cssPrefix;

  // For title of the page
  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('browserTitles.termsOfService')
      .toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: this.loggedIn ? true : false,
      isShowSlash: this.loggedIn ? true : false,
      isShowParent: this.loggedIn ? true : false,
    };
  }
}
